import { dollars } from './buildings';
import { TICKS_PER_GAME_HOUR } from './constants';

/*
 * Marketing: money spent to make the airport known. A social media campaign lifts the online
 * mood at once (once a day); an airline roadshow (route development) makes airlines call more
 * often for two days. Wire and save ids: append only.
 */

export const Campaign = { Social: 0, Roadshow: 1 } as const;
export type CampaignId = (typeof Campaign)[keyof typeof Campaign];

export const CAMPAIGN_COST: readonly number[] = [dollars(25_000), dollars(60_000)];
/** Online mood added by a social media campaign, and how long before the next one. */
export const SOCIAL_BUZZ = 250;
export const SOCIAL_COOLDOWN_TICKS = 24 * TICKS_PER_GAME_HOUR;
/** How long a roadshow lasts, and how much more often airlines call meanwhile (percent). */
export const ROADSHOW_TICKS = 48 * TICKS_PER_GAME_HOUR;
export const ROADSHOW_OFFER_PERCENT = 150;
